(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["g_password-footer"]) return;
  try {
    
    const pwdFooter = document.querySelector('[data-password-footer]');
    document.documentElement.style.setProperty('--password-footer-height', `${pwdFooter.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["g_password-header"]) return;
  try {
    
    const pwdHeader = document.querySelector('[data-password-header]');
    document.documentElement.style.setProperty('--password-header-height', `${pwdHeader.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s_infinite-scroll"] && !Shopify.designMode) return;
  try {
    
(function () {
  var config = document.querySelector('[data-infinite-scroll]');
  if (!config) return;

  var trigger = config.dataset.trigger || 'scroll';
  var loadMoreText = config.dataset.loadMore || 'Load more';
  var loadingText = config.dataset.loading || 'Loading…';

  var loading = false;
  var nextUrl = null;
  var sentinel = null;
  var spinnerEl = null;
  var btnWrap = null;
  var observer = null;
  var mutObs = null;
  var dynamicBlock = null;

  function getGrid(root) {
    if (!root) return null;
    return root.querySelector('[class*="#grid"][class*="@type:columns"]');
  }

  function extractNextUrl(root, currentPage) {
    if (!root) return null;
    var target = currentPage + 1;

    // Check anchor tags first — always present, no custom element dependency
    var links = root.querySelectorAll('a[href*="page="]');
    for (var i = 0; i < links.length; i++) {
      try {
        var u = new URL(links[i].getAttribute('href'), location.origin);
        if (parseInt(u.searchParams.get('page') || '0', 10) === target) {
          return links[i].getAttribute('href');
        }
      } catch (e) {}
    }

    // Fallback: collection-nav-item[to] attributes
    var items = root.querySelectorAll('collection-nav-item[to]');
    for (var j = 0; j < items.length; j++) {
      try {
        var u2 = new URL(items[j].getAttribute('to'), location.origin);
        if (parseInt(u2.searchParams.get('page') || '0', 10) === target) {
          return items[j].getAttribute('to');
        }
      } catch (e) {}
    }
    return null;
  }

  function hidePagination() {
    // Attribute-driven CSS hiding is more reliable than inline style
    if (dynamicBlock) dynamicBlock.setAttribute('data-inf-scroll-active', '');
  }

  function showPagination() {
    if (dynamicBlock) dynamicBlock.removeAttribute('data-inf-scroll-active');
  }

  function cleanup() {
    showPagination();
    if (observer) { observer.disconnect(); observer = null; }
    if (sentinel) { sentinel.remove(); sentinel = null; }
    if (spinnerEl) { spinnerEl.remove(); spinnerEl = null; }
    if (btnWrap) { btnWrap.remove(); btnWrap = null; }
    loading = false;
    nextUrl = null;
  }

  function setup() {
    if (!dynamicBlock) return;

    var currentPage = parseInt(
      new URLSearchParams(location.search).get('page') || '1',
      10
    );
    nextUrl = extractNextUrl(dynamicBlock, currentPage);
    if (!nextUrl) return;

    hidePagination();

    var grid = getGrid(dynamicBlock);
    if (!grid) return;

    if (trigger === 'button') {
      setupButton(grid);
    } else {
      setupScroll(grid);
    }
  }

  function setupButton(grid) {
    btnWrap = document.createElement('div');
    btnWrap.className = 'inf-scroll-btn-wrap';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'inf-scroll-btn';
    btn.textContent = loadMoreText;
    btn.addEventListener('click', loadMore);

    spinnerEl = document.createElement('div');
    spinnerEl.className = 'inf-scroll-spinner';
    spinnerEl.hidden = true;
    spinnerEl.setAttribute('aria-live', 'polite');
    spinnerEl.setAttribute('aria-label', loadingText);

    btnWrap.appendChild(btn);
    btnWrap.appendChild(spinnerEl);
    grid.insertAdjacentElement('afterend', btnWrap);
  }

  function setupScroll(grid) {
    sentinel = document.createElement('div');
    sentinel.className = 'inf-scroll-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    grid.insertAdjacentElement('afterend', sentinel);

    spinnerEl = document.createElement('div');
    spinnerEl.className = 'inf-scroll-spinner';
    spinnerEl.hidden = true;
    spinnerEl.setAttribute('aria-live', 'polite');
    spinnerEl.setAttribute('aria-label', loadingText);
    sentinel.insertAdjacentElement('afterend', spinnerEl);

    observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting && !loading) loadMore();
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    observer.observe(sentinel);
  }

  async function loadMore() {
    if (loading || !nextUrl) return;
    loading = true;
    setLoading(true);

    try {
      var fetchedPage = parseInt(
        new URL(nextUrl, location.origin).searchParams.get('page') || '1',
        10
      );
      var res = await fetch(nextUrl);
      if (!res.ok) throw new Error('fetch ' + res.status);

      var doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      var fetchedBlock = doc.querySelector('div[data-collection-dynamic-block]');
      var newGrid = getGrid(fetchedBlock);
      if (!newGrid) throw new Error('grid not found in response');

      var currentGrid = getGrid(dynamicBlock);
      if (!currentGrid) throw new Error('current grid missing');

      Array.from(newGrid.children).forEach(function (card) {
        currentGrid.appendChild(card.cloneNode(true));
      });

      nextUrl = extractNextUrl(fetchedBlock, fetchedPage);

      if (!nextUrl) cleanup();
    } catch (err) {
      console.warn('[infinite-scroll]', err);
    }

    loading = false;
    setLoading(false);
  }

  function setLoading(on) {
    if (spinnerEl) spinnerEl.hidden = !on;
    if (btnWrap) {
      var btn = btnWrap.querySelector('.inf-scroll-btn');
      if (btn) {
        btn.disabled = on;
        btn.textContent = on ? loadingText : loadMoreText;
      }
      if (!nextUrl && !on) btnWrap.remove();
    }
  }

  function watchRerenders() {
    if (!dynamicBlock) return;
    var parent = dynamicBlock.parentElement;
    if (!parent) return;

    mutObs = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && node.nodeName === 'DIV' && node.hasAttribute('data-collection-dynamic-block')) {
            cleanup();
            dynamicBlock = node;
            setup();
          }
        });
      });
    });

    mutObs.observe(parent, { childList: true });
  }

  function init() {
    dynamicBlock = document.querySelector('div[data-collection-dynamic-block]');
    if (!dynamicBlock) return;
    setup();
    watchRerenders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
